<template>
  <section>
    <div class="my-3">
      <v-layout row wrap justify-space-between>
        <v-flex xs3 fluid align-center justyfy-center>
          <v-dialog persistent v-model="modalWindow" max-width="900">
            <v-btn color="primary" dark slot="activator" class="mb-2" v-if="isWriteAvailable">Add task of sponsor</v-btn>
            <v-card>
              <v-card-title>
                <h2>{{ formTitle }}</h2>
              </v-card-title>
              <v-card-text>
                <v-form class="my-3" @submit.prevent="save">
                  <v-flex xs12>
                    <content-field label="Title" :error="$v.formData.title" v-model="formData.title"/>
                  </v-flex>
                </v-form>
              </v-card-text>
              <v-card-actions class="pa-4">
                <v-spacer/>
                <v-btn color="error" dark large @click.stop="close">Cancel</v-btn>
                <v-btn color="success" dark large @click.stop="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>

      <table-sponsor-task />
    </div>
  </section>
</template>
<script>
import ContentField from '@/components/shared/ContentField'
import TableSponsorTask from './TableSponsorTask.vue'
import { required } from 'vuelidate/lib/validators'
import {mapActions, mapGetters} from 'vuex'
import lodash from 'lodash'
import mixins from '@/utils/mixins'

export default {
  components: {
    ContentField,
    TableSponsorTask
  },
  name: 'SponsorTasks',
  mixins: [mixins.isWriteAvailable],
  data () {
    return {
      formData: {
        title: ''
      },
      modalWindow: false,
      isEditItem: false,
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'sponsors:write'
    }
  },
  computed: {
    formTitle () {
      return !this.isEditItem ? 'New Task' : 'Edit Task'
    }
  },
  methods: {
    ...mapActions([
      'createSponsorTask',
      'editSponsorTask',
      'deleteSponsorTask',
      'fetchSponsorTasksList'
    ]),
    toggleModal (varModal) {
      this[varModal] = !this[varModal]
    },
    async save () {
      this.$v.formData.$touch()
      if (this.$v.formData.$invalid) {return }
      try {
        this.isEditItem
          ? await this.editSponsorTask(this.formData)
          : await this.createSponsorTask(this.formData)
        this.close()
        this.reset()
        this.fetchSponsorTasksList()
      } catch (err) {
        throw err
      }
    },
    close () {
      this.toggleModal('modalWindow')
      this.isEditItem = false
      this.$v.formData.$reset()
      this.reset()
    },
    getNewList(params) {
      this.fetchSponsorTasksList(params)
    },
    reset () {
      this.formData.title = ''
    }
  },
  validations: {
    formData: {
      title: {required}
    }
  },
  created () {
    this.$bus.$on('editSponsorTask', item => {
      this.formData = lodash.cloneDeep(item)
      this.isEditItem = true
      this.toggleModal('modalWindow')
    })
    this.fetchSponsorTasksList()
  },
  beforeDestroy () {
    this.$bus.$off('editSponsorTask')
  }
}
</script>
<style lang="scss" scoped>
/deep/ .vc-chrome {
  position: absolute;
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Sponsors/Settings/SponsorsTasks/index.vue